import 'pixi';
import 'p2';
import Phaser from 'phaser';

import BootState from './states/Boot';
import PreloaderState from './states/Preloader';
import MenuState from './states/Menu';
import MissionState from './states/Mission';
import PracticeState from './states/Practice';

import dimensions from './dimensions';

class Game extends Phaser.Game {
    constructor() {
        let ratio = 1;

        if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) ratio = window.screen.systemXDPI / window.screen.logicalXDPI;else if (window.devicePixelRatio !== undefined) ratio = window.devicePixelRatio;

        if (window.innerWidth > window.innerHeight) {
            dimensions.fullWidth = window.innerWidth * ratio;
            dimensions.fullHeight = window.innerHeight * ratio;
        } else {
            dimensions.fullWidth = window.innerHeight * ratio;
            dimensions.fullHeight = window.innerWidth * ratio;
        }

        super(dimensions.fullWidth, dimensions.fullHeight, Phaser.CANVAS, 'content', null);

        this.state.add('Boot', BootState, false);
        this.state.add('Preloader', PreloaderState, false);
        this.state.add('Menu', MenuState, false);
        this.state.add('Mission', MissionState, false);
        this.state.add('Practice', PracticeState, false);

        this.state.start('Boot');
    }
}

window.game = new Game();


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 140
// module chunks = 0